<template>
    <div class="antialiased">
        <Sidebar/>
        <div class="page">
            <Header hint="Cari...." :enabled="false"></Header>
            <div class="content">
                <div class="container">
                    <!-- Page Header -->
                    <div class="page-header">
                        <div class="row d-flex justify-content-between">
                            <div class="col-auto">
                                <h2 class="page-title"> Laporan Retur Sales</h2>
                            </div>

                            <div class="col-auto">
                                <div class="row">
                                    <div class="col-auto p-0">
                                        <button class="btn btn-white" v-html="ic('filter') + ' Filter'" @click="isModal"></button>
                                    </div>
                                    <div class="col-auto p-0 ml-2">
                                        <div class=" input-icon">
                                            <span class="input-icon-addon">
                                                <i class="fe fe-pie-chart"></i>
                                            </span>
                                            <select class="form-control text-capitalize" @change="_get" v-model="filters.group_by" :disabled="page.loadingReportData">
                                                <option
                                                    v-for="(group, index) in ['toko', 'tim']"
                                                    v-html="group"
                                                    :value="group"
                                                    :key="index">
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-auto p-0">
                                        <button class="btn btn-primary ml-2" v-html="datas.report.length <= 0 && !page.loadingReportData <= 0? spin() : ic('download')+'Download Excel'" :disabled="datas.report.length <= 0" @click="_createExcel"> </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="alert alert-info"><i class="fe fe-info mr-2"></i> Pilih filter untuk memuat data retur sales lebih detail</div>
                   
                    <Skeleton type="table" :length="22" class="mt-4 bg-white" v-if="page.loadingDashboardData"/> 

                    <Nodata class="mt-5" v-if="!page.loadingDashboardData && datas.dashboard.rankSalesRetur.length === 0"/>

                    <div class="box" v-if="!page.loadingDashboardData && datas.dashboard.rankSalesRetur.length > 0">
                        <div class="card">
                            <div class="table-responsive">
                                <table class="table table-vcenter table-hover card-table table-striped table-control"> 
                                    <thead>
                                        <tr class="text-capitalize">
                                            <th class="header">NO</th>
                                            <th class="header" v-for="(header, index) in page.headers">{{header.replace('_', ' ')}}</th>
                                            <th class="header" style="width: 20%;">TOTAL RETUR</th>
                                            <th class="header" style="width: 20%;">TOTAL SALES</th>
                                            <th class="header text-center" style="width: 14%;">PRESENTASE</th>
                                        </tr>
                                    </thead>
                                    <tbody class="">
                                        <tr v-for="(rankSales, index) in datas.dashboard.rankSalesRetur" :key="index">
                                            <td>{{index + 1}}</td>
                                            <td v-for="(header, index) in page.headers">{{rankSales[header]}}</td>
                                            <td>{{ ribuan(rankSales.total_retur.toFixed(0))  }}</td>
                                            <td>{{ ribuan(rankSales.total_sales.toFixed(0))  }}</td>
                                            <td class="text-center">
                                                <b-button size="sm" :variant="colorPresentase(rankSales.total_retur,rankSales.total_sales)">
                                                    {{calculatePresentase(rankSales.total_retur,rankSales.total_sales)}}
                                                </b-button>
                                            </td>
                                        </tr>
                                        <tr v-if="datas.dashboard.otherOutlet.total_retur !== 0 || datas.dashboard.otherOutlet.total_sales !== 0 ">
                                            <td v-if="filters.group_by == 'toko'"></td>
                                            <td></td>
                                            <td>Total Other Outlet</td>
                                            <td>{{ ribuan(datas.dashboard.otherOutlet.total_retur.toFixed(0)) }}</td>
                                            <td>{{ ribuan(datas.dashboard.otherOutlet.total_sales.toFixed(0)) }}</td>
                                            <td class="text-center">
                                                <b-button size="sm" :variant="colorPresentase(datas.dashboard.otherOutlet.total_retur, datas.dashboard.otherOutlet.total_sales)">
                                                    {{ calculatePresentase(datas.dashboard.otherOutlet.total_retur, datas.dashboard.otherOutlet.total_sales) }}
                                                </b-button>
                                            </td>
                                        </tr>
                                        <tr class="font-weight-bold">
                                            <td v-if="filters.group_by == 'toko'"></td>
                                            <td></td>
                                            <td>Grand Total</td>
                                            <td>{{ ribuan(datas.dashboard.grandTotal.total_retur.toFixed(0)) }}</td>
                                            <td>{{ ribuan(datas.dashboard.grandTotal.total_sales.toFixed(0)) }}</td>
                                            <td class="text-center">
                                                <b-button size="sm" :variant="colorPresentase(datas.dashboard.grandTotal.total_retur, datas.dashboard.grandTotal.total_sales)">
                                                    {{ calculatePresentase(datas.dashboard.grandTotal.total_retur, datas.dashboard.grandTotal.total_sales) }}
                                                </b-button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <ModalFilter></ModalFilter>
    </div>
</template>
<script>
import helper from "@/assets/js/helper.js";
import ModalFilter from "./modals/filter.vue";
import { mapState, mapActions } from "vuex";

export default({
    name: "LaporanReturSales",
    components: { ModalFilter },
    mixins: [helper],
    computed: {
        ...mapState("sales_retur",['filters','datas','page']),
    },
    methods: {
        ...mapActions("sales_retur",['getSalesReturDashboard','getSalesReturReport','isModal']),
        async _get(){
            this.getSalesReturDashboard()
            this.getSalesReturReport()
        },
        calculatePresentase(total_retur,total_sales){
            return total_sales == 0 ? 'Overclaim' : ((total_retur / total_sales) * 100).toFixed(1) + '%'
        },
        colorPresentase(total_retur,total_sales){
            let calculate = total_sales == 0 ? 'Overclaim' : ((total_retur / total_sales) * 100).toFixed(1)
            return calculate == 'Overclaim' || calculate >= 1 ? 'danger' : 'success';
        },
        _createExcel() {
            let dataExcel = [];
            this.datas.report.forEach(function(data) {
                let formatted = {
                    'Distributor': data.nama_perusahaan,
                    'Depo': data.nama_depo,
                    'Supervisor': data.nama_spv,
                    'Team': data.nama_tim,
                    'Salesman': data.nama_salesman,
                    'Custno': data.cust_no,
                    'Cusname': data.nama_toko,
                    'Total Retur': data.total_retur,
                    'Total Sales': data.total_sales,
                    'Presentase %': data.total_sales == 0 ? 'Overclaim' : ((data.total_retur / data.total_sales) * 100).toFixed(1),
                }
                dataExcel.push(formatted);
            });

            this.createExcel({
                data: dataExcel,
                filename:"laporan-sales-retur"
            });
        },
    },
})
</script>
<style scoped>
    .header{
        font-size: 0.75rem;
        font-weight: 800;
    }
    .sub-header{
        font-size: 0.75rem;
        font-weight: 700;
        opacity: 70%;
    }
</style>


